import EmbedPage from '@educator/Container/EmbedPage/EmbedPage';
import { fetchPost } from '@actions/moderator';

const Embed = () => <EmbedPage />;

Embed.getInitialProps = async ({ store, query }) => {
  const { lessonUID } = query;
  await store.dispatch(fetchPost(lessonUID));
};

Embed.pageInfo = {
  layoutOptions: {
    isCheckoutUrl: true,
    hideFooter: true,
    hideIntercom: true,
    hideFreshbot: true
  }
};

export default Embed;
